import { render, staticRenderFns } from "./CoursewareStructuralElementDialogExportChooser.vue?vue&type=template&id=47e4993f&scoped=true&"
import script from "./CoursewareStructuralElementDialogExportChooser.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementDialogExportChooser.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareStructuralElementDialogExportChooser.vue?vue&type=style&index=0&id=47e4993f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e4993f",
  null
  
)

export default component.exports